import { render, staticRenderFns } from "./Scenarios.vue?vue&type=template&id=5163bb64&scoped=true&"
import script from "./Scenarios.vue?vue&type=script&lang=js&"
export * from "./Scenarios.vue?vue&type=script&lang=js&"
import style0 from "./Scenarios.vue?vue&type=style&index=0&id=5163bb64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5163bb64",
  null
  
)

export default component.exports